import { Component, type OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { environment } from '@tv3/environments/environment'
import { AuthService } from '@tv3/services/auth.service'

@Component({
  selector: 'app-subscribe-rategenie',
  templateUrl: './subscribe-rategenie.html',
  styleUrls: ['./subscribe-rategenie.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SubscribeRategenie implements OnInit {
  isConnected = false
  constructor(private auth: AuthService, public dialogRef: MatDialogRef<SubscribeRategenie>) {}

  close() {
    this.dialogRef.close(this.isConnected)
  }

  ngOnInit(): void {}

  onConnect() {
    this.isConnected = true
    window.open(`${environment.appStoreUrl}/login?redirect=/details/rategenie&token=${this.auth.token}`, '_blank')
  }
}
